"use strict";

exports.__esModule = true;
exports.getRequiredChunkKey = exports.Context = exports.invariant = void 0;
var _component = require("@loadable/component");

/* eslint-disable no-underscore-dangle */
const {
  invariant,
  Context,
  getRequiredChunkKey
} = _component.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
exports.getRequiredChunkKey = getRequiredChunkKey;
exports.Context = Context;
exports.invariant = invariant;